<template>
  <v-row class="px-1">
    <v-col md="5">
      <span>&copy; 2019 - All Rights Reserved.</span>
      <span> version - {{ version }} </span>
      <v-btn :to="{ name: 'realhrsoft-help' }" router small text disabled>
        Help
      </v-btn>
    </v-col>
    <v-col md="7" class="pl-12">
      <v-btn :to="{ name: 'realhrsoft-terms-and-condition' }" small text>
        Terms and Conditions
      </v-btn>
      <v-btn :to="{ name: 'realhrsoft-privacy-and-policy' }" small text>
        Privacy and Policy
      </v-btn>
      <v-btn :to="{ name: 'realhrsoft-about' }" small text>
        About
      </v-btn>
      <v-btn :to="{ name: 'realhrsoft-contact' }" small text>
        Contact
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      version: "0.0.0"
    };
  }
};
</script>

<style scoped></style>
